<template>
	<div style="padding:20px">
		<el-row>
			<el-col :span="12">
				<el-input placeholder="请输入内容" v-model="body" clearable> </el-input><br /><br />
			</el-col>
			<el-col :span="12">
				<el-button style="margin-left:20px" type="primary" @click="send">发送</el-button>
				<el-button style="margin-left:20px" type="success" @click="clear">清空</el-button><br /><br />

			</el-col>
		</el-row>
		<el-row>
			<!-- 查询条件 -->
			<el-col :span="18" class="handleQuery">
				<el-input type="textarea" :autosize="{ minRows: 20}" placeholder="请输入内容" v-model="textarea">
				</el-input>
			</el-col>

		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				textarea: "",
				body: "",
				close: false
			};
		},
		filters: {},
		methods: {
			query() {
				var that = this;
				this.$http({
						method: 'POST',
						url: 'device/query'
					})
					.then((res) => {
						if (res.data.data) {
							console.log(res.data.data)
							that.textarea = that.textarea + res.data.data
						}
						if (!this.close) {
							setTimeout(that.query(), 50);
						}
					})
			},
			send() {
				var that = this;
				this.$http({
						method: 'POST',
						url: 'device/send',
						data: that.body,
						headers: {
							'Content-Type': 'text/plain' // 这里设置您的Content-Type
						}
					})
					.then(() => {
						//that.textarea=that.textarea+that.body
					})
			},
			clear() {
				this.textarea = ""
			}
		},
		mounted: function() {
			setTimeout(this.query(), 10);
		},
		destroyed: function() {
			this.close = true
		}
	};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/view/front/test/device.vue